module.exports = __webpack_public_path__ + "img/tyg_solution2.52db02d9.png";